(function () {
    var $body = $('body'),
        $window = $(window),
        tabKey = 9,
        shift = 16;

    var modal = {
        $toggle: $('[data-toggle="modal"]'),
        $target: null,
        revers: false,
        lastItem: null,
        items: null,
        $close: null,
        accessibilityEnabled: true,

        init: function () {
            if (this.accessibilityEnabled) modal.accessibility.init();
            modal.$target = $(modal.$toggle.data('target'));
            modal.control();
        },
        accessibility: {
            init: function () {
                // Move every modal outside of content in order to be able hide and show page content for screen readers
                // @note: for some reason, it is not working with tab trap correctly, when we append it to body - after(.content) works fine
                var $content = $('main.content');
                if ($content.length) {
                    $content.after($('.ux-modal-container'));
                }
                // Text for close buttons
                $('[data-dismiss="modal"]').append('<span class="sr-only">Close modal</span>');
            },
            show: function () {
                $('.content, .footer, .header').attr('aria-hidden', true);
            },
            hide: function () {
                $('.content, .footer, .header').removeAttr('aria-hidden');
            },
        },
        control: function () {
            $body.on('click', '[data-toggle="modal"]', function (e) {
                e.preventDefault();
                modal.$toggle = $(this);
                modal.$target = $(modal.$toggle.data('target'));
                modal.$close = modal.$target.find('.close');
                modal.items = modal.$target.find('a, button, input');
                modal.items.each(function (index) {
                    if (index === modal.items.length - 1) {
                        modal.lastItem = $(this);
                    }
                });
                modal.on.show();
            });

            $body.on('click', '.modal', function (e) {
                var target = $(e.target);
                if (!target.is('.modal__dialog') && !target.closest('.modal__dialog').length > 0) {
                    //e.preventDefault();
                    modal.on.hide();
                }
            });

            $body.on('click', '[data-dismiss="modal"]', function (e) {
                modal.on.hide();
            });

            $('.modal').on('keydown', modal.focusCycle.bind(modal));

            $window.on('keyup', function (e) {
                if (e.keyCode === shift) {
                    modal.revers = false;
                }
            });
        },
        on: {
            show: function (e) {
                if (typeof UX.controller !== 'undefined') {
                    UX.controller.check();
                }
                setTimeout(function () {
                    $body.attr('data-active', 'modal');
                    modal.accessibility.show();
                    const $autofocus = modal.$target.find('[autofocus]');
                    if ($autofocus.length) $autofocus.focus();
                    else modal.$close.focus();
                }, 250);
                modal.$target.closest("[class*='sticko']").addClass('js--open');
                $('#externalEmailDialogForm').addClass('pairing-management-modal');
            },
            hide: function () {
                $body.removeAttr('data-active');
                modal.accessibility.hide();
                modal.$target.closest("[class*='sticko']").removeClass('js--open');
            },
            tab: function () {
                modal.$close.off('focusout');
                modal.lastItem.off('focusout');
                modal.lastItem.on('focusout', function () {
                    modal.$close.focus();
                });
            },
            tabRevers: function () {
                modal.lastItem.off('focusout');
                modal.$close.off('focusout');
                modal.$close.on('focusout', function () {
                    modal.lastItem.focus();
                });
            },
        },
        focusCycle: function (e) {
            if (e.keyCode === shift) {
                modal.revers = true;
            }

            if ((e.keyCode || e.which) === tabKey) {
                if (!modal.revers) {
                    modal.on.tab();
                } else {
                    modal.on.tabRevers();
                }
            }
        },
    };

    UX.modal = modal; // add to global namespace
})();
